import React from 'react';
import { Separator } from '../ui/separator';
import { VoucherField } from '../VoucherField';
import { useCurrency } from '../CurrencySelector';

export const OrderSummary = ({
  cart, voucher, onVoucherApplied, onVoucherCleared,
  selectedQuote, shippingPrice, amountDue, language, t, getLocalizedName,
}) => {
  const { format, code } = useCurrency();
  return (
  <div className="bg-white rounded-xl border border-border/40 p-6 sticky top-32">
    <h2 className="text-lg font-bold mb-4">
      {language === 'fr' ? 'Récapitulatif' : 'Order Summary'}
    </h2>

    <div className="space-y-3 mb-4 max-h-64 overflow-y-auto">
      {cart.items?.map((item) => (
        <div key={item.product_id} className="flex gap-3">
          <img
            src={item.image || 'https://via.placeholder.com/60'}
            alt={getLocalizedName(item)}
            className="w-16 h-16 rounded-lg object-cover"
          />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium line-clamp-2">{getLocalizedName(item)}</p>
            <p className="text-xs text-muted-foreground">
              {item.quantity} × {format(item.price)}
            </p>
          </div>
          <p className="font-medium text-sm">
            {format(item.quantity * item.price)}
          </p>
        </div>
      ))}
    </div>

    <Separator className="my-4" />

    <div className="mb-3">
      <VoucherField
        subtotal={cart.total || 0}
        applied={voucher}
        onApplied={onVoucherApplied}
        onCleared={onVoucherCleared}
      />
    </div>

    <Separator className="my-3" />

    <div className="space-y-2">
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">{t('subtotal')}</span>
        <span>{format(cart.total)}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-muted-foreground">{t('shipping')}</span>
        <span className={shippingPrice === 0 ? 'text-green-600' : ''}>
          {selectedQuote ? (
            shippingPrice === 0
              ? (language === 'fr' ? 'Gratuit' : 'Free')
              : format(shippingPrice)
          ) : '—'}
        </span>
      </div>
      {selectedQuote && (
        <p className="text-xs text-muted-foreground -mt-1 truncate" data-testid="summary-carrier-name">
          {selectedQuote.name} · {selectedQuote.eta_days} {language === 'fr' ? 'jours' : 'days'}
        </p>
      )}
      {voucher && (
        <div className="flex justify-between text-sm" data-testid="voucher-line">
          <span className="text-green-700 font-medium">
            {language === 'fr' ? 'Code' : 'Voucher'} {voucher.code}
          </span>
          <span className="text-green-700 font-semibold">−{format(voucher.discount)}</span>
        </div>
      )}
      <Separator className="my-2" />
      <div className="flex justify-between font-bold text-lg">
        <span>{t('total')}</span>
        <span className="text-[#0F4C5C]">€{(amountDue || 0).toFixed(2)}</span>
      </div>
      {code !== 'EUR' && (
        <p className="text-xs text-muted-foreground text-right" data-testid="summary-converted-note">
          ≈ {format(amountDue)} · {language === 'fr' ? 'facturé en EUR' : 'billed in EUR'}
        </p>
      )}
    </div>
  </div>
  );
};
